import { render, staticRenderFns } from "./QuickLinkDetailPage.vue?vue&type=template&id=b58df1d4"
import script from "./QuickLinkDetailPage.vue?vue&type=script&lang=js"
export * from "./QuickLinkDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports